import { createAction, props } from '@ngrx/store'
import { AppliedLeave } from './applied-leave.state'

// Action to load Designation
export const loadAppliedLeaves = createAction(
  '[AppliedLeave] Load AppliedLeaves',
  props<{ params: string | null; page?: number; limit?: number }>()
)

// Action for successful AppliedLeave load
export const loadAppliedLeavesSuccess = createAction(
  '[AppliedLeave] Load AppliedLeave Success',
  props<{
    totalCount: number
    appliedLeaves: AppliedLeave[]
  }>()
)

// Action for AppliedLeave load failure
export const loadAppliedLeavesFailure = createAction(
  '[AppliedLeave] Load AppliedLeave Failure',
  props<{ error: string }>()
)

export const loadAppliedLeaveCounts = createAction('[AppliedLeave] Load Counts')
export const setAppliedLeaveCounts = createAction(
  '[AppliedLeave] Set Counts',
  props<{ totalCount: number }>()
)

export const createAppliedLeave = createAction(
  '[AppliedLeave] Create AppliedLeave',
  props<{
    payload: any
  }>()
)

export const createAppliedLeaveSuccess = createAction(
  '[AppliedLeave] Create AppliedLeave Success',
  props<{ appliedLeave: AppliedLeave }>()
)

export const createAppliedLeaveFailure = createAction(
  '[AppliedLeave] Create AppliedLeave Failure',
  props<{ error: any }>()
)

export const updateAppliedLeave = createAction(
  '[AppliedLeave] Update AppliedLeave',
  props<{
    id: string
    payload: any
  }>()
)

export const updateAppliedLeaveSuccess = createAction(
  '[AppliedLeave] Update AppliedLeave Success',
  props<{ appliedLeave: AppliedLeave }>()
)

export const updateAppliedLeaveFailure = createAction(
  '[AppliedLeave] Update AppliedLeave Failure',
  props<{ error: any }>()
)
